import * as yup from 'yup';

export const LcSepseSchema = yup.object().shape({

  // Dados Gerais
  num_registro_sepse: yup
    .number()
    .typeError('Campo obrigatório. Máximo 5 dígitos.')
    .required('Campo obrigatório'),
  sexo_sepse: yup.string().nullable(true),
  dn_sepse: yup.string().nullable(true),
  convenio_sepse: yup.string().nullable(true),


  // Comorbidades
  imuno_sepse: yup.string().nullable(true),
  neoplasia_sepse: yup.string().nullable(true),
  avc_sepse: yup.string().nullable(true),
  cirrose_sepse: yup.string().nullable(true),
  drc_sepse: yup.string().nullable(true),
  dm_sepse: yup.string().nullable(true),

  // Dados da Doença

  infeccao_sepse: yup.string().nullable(true),
  apre_clinica_sepse: yup.string().nullable(true),

  // Exames

  pas_diagnostico_sepse: yup.string().nullable(true),
  pad_diagnostico_sepse: yup.string().nullable(true),
  lactato1_resultado_sepse: yup.string().nullable(true),
  lactato1_unidade_sepse: yup.string().nullable(true),
  lactato2_resultado_sepse: yup.string().nullable(true),
  lactato2_unidade_sepse: yup.string().nullable(true),

  // Tratamento

  antimicrobiano_previo_sepse: yup.string().nullable(true),
  rep_vol_realizacao_sepse: yup.string().nullable(true),
  rep_vol_data_sepse: yup.string().nullable(true),
  rep_vol_hora_sepse: yup.string().nullable(true),
  pas_infusao_sepse: yup.string().nullable(true),
  pad_infusao_sepse: yup.string().nullable(true),
  pa_infusao_data_sepse: yup.string().nullable(true),
  pa_infusao_hora_sepse: yup.string().nullable(true),
  vasop_realizacao_sepse: yup.string().nullable(true),
  vasop_data_sepse: yup.string().nullable(true),
  vasop_hora_sepse: yup.string().nullable(true),
  paliativos_sepse: yup.string().nullable(true),

  // Início Sintomas

  sintomas_local_sepse: yup.string().nullable(true),

  // Data e Hora Sintomas

  sintomas_data_sepse: yup.string().nullable(true),
  sintomas_hora_sepse: yup.string().nullable(true),

  // Data e Hora Impressão

  diagnostico_data_sepse: yup.string().nullable(true),
  diagnostico_hora_sepse: yup.string().nullable(true),

  // Data e Hora Revisão

  revisao_data_sepse: yup.string().nullable(true),
  revisao_hora_sepse: yup.string().nullable(true),

  // Data e Hora Primeira Coleta

  lactato1_data_sepse: yup.string().nullable(true),
  lactato1_hora_sepse: yup.string().nullable(true),


  // Data e Hora Primeira Hemocultura

  hemocultura_data_sepse: yup.string().nullable(true),
  hemocultura_hora_sepse: yup.string().nullable(true),

  // Data e Hora Segunda Coleta

  lactato2_data_sepse: yup.string().nullable(true),
  lactato2_hora_sepse: yup.string().nullable(true),

  // Data e Hora Antimicrobiano

  antimicrobiano_data_sepse: yup.string().nullable(true),
  antimicrobiano_hora_sepse: yup.string().nullable(true),


  // Dados da saída

  saida_data_sepse: yup.string().nullable(true),
  saida_hora_sepse: yup.string().nullable(true),
  // covid_sepse: yup.string().nullable(true),
  saida_motivo_sepse: yup.string().nullable(true),
});
